import React, { useState } from 'react';
import { ShoppingCartIcon } from 'lucide-react';
import { Modal } from './Modal';
import { PrivacyPolicy } from './PrivacyPolicy';
import { TermsAndConditions } from './TermsAndConditions';
import { ContactForm } from './ContactForm';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | 'contact' | null>(null);
  return <>
      <footer className="relative bg-gradient-to-br from-gray-950 via-gray-900 to-black text-white py-12 sm:py-16 md:py-20 overflow-hidden" data-id="element-177">
        {/* Animated Background Effects */}
        <div className="absolute inset-0 opacity-30" data-id="element-178">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-amber-500/20 rounded-full blur-3xl animate-pulse" data-id="element-179"></div>
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-orange-500/20 rounded-full blur-3xl animate-pulse delay-1000" data-id="element-180"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6" data-id="element-181">
          {/* Premium Newsletter Section */}

          {/* Footer Links - Centered */}
          <div className="flex flex-col items-center mb-12 sm:mb-16" data-id="element-182">
            <ul className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 md:gap-12 mb-10 text-gray-400" data-id="element-183">
              <li data-id="element-184">
                <button onClick={() => setActiveModal('contact')} className="hover:text-amber-400 transition-colors duration-300 text-sm sm:text-base font-medium" data-id="element-185">
                  Contacto
                </button>
              </li>
              <li className="hidden sm:block w-px h-4 bg-amber-500/20" data-id="element-186"></li>
              <li data-id="element-187">
                <button onClick={() => setActiveModal('terms')} className="hover:text-amber-400 transition-colors duration-300 text-sm sm:text-base font-medium" data-id="element-188">
                  Términos y Condiciones
                </button>
              </li>
              <li className="hidden sm:block w-px h-4 bg-amber-500/20" data-id="element-189"></li>
              <li data-id="element-190">
                <button onClick={() => setActiveModal('privacy')} className="hover:text-amber-400 transition-colors duration-300 text-sm sm:text-base font-medium" data-id="element-191">
                  Política de Privacidad
                </button>
              </li>
            </ul>

            {/* Premium 3D Gold Facebook Icon - Centered */}
            <div className="flex justify-center" data-id="element-192">
              <a href="https://www.facebook.com/contactokd" target="_blank" rel="noopener noreferrer" className="group relative" data-id="element-193">
                <div className="absolute inset-0 bg-gradient-to-br from-amber-400 to-orange-500 rounded-2xl blur-xl opacity-0 group-hover:opacity-75 transition-opacity duration-300" data-id="element-194"></div>
                <div className="relative w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-amber-300 via-amber-400 to-amber-600 rounded-2xl flex items-center justify-center shadow-2xl transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-300 border-2 border-amber-200/50" data-id="element-195">
                  <div className="absolute inset-0 bg-gradient-to-br from-white/40 to-transparent rounded-2xl" data-id="element-196"></div>
                  <svg className="w-7 h-7 sm:w-8 sm:h-8 relative z-10" fill="currentColor" viewBox="0 0 24 24" style={{
                  filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))',
                  color: '#1a1a1a'
                }} data-id="element-197">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-198" />
                  </svg>
                </div>
              </a>
            </div>
          </div>

          {/* Premium Copyright Section */}
          <div className="text-center pt-8 border-t border-amber-500/20" data-id="element-199">
            <p className="text-gray-400 text-xs sm:text-sm mb-4 max-w-3xl mx-auto leading-relaxed" data-id="element-200">
              Los resultados pueden variar según la consistencia de
              implementación del sistema. Las estadísticas están basadas en
              encuestas a usuarios activos del programa.
            </p>
            <p className="text-gray-500 text-xs sm:text-sm" data-id="element-201">
              ©{' '}
              <span className="text-amber-400 font-semibold" data-id="element-202">
                Sistema 15/15 LATAM
              </span>{' '}
              2025 • Todos los Derechos Reservados
            </p>
          </div>
        </div>
      </footer>

      {/* Modals */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-203">
        <PrivacyPolicy data-id="element-204" />
      </Modal>
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-205">
        <TermsAndConditions data-id="element-206" />
      </Modal>
      <Modal isOpen={activeModal === 'contact'} onClose={() => setActiveModal(null)} title="Contacto" data-id="element-207">
        <ContactForm data-id="element-208" />
      </Modal>
    </>;
}